import classNames from 'classnames';
import React from 'react';

import { ISG_COLUMN_HEADERS } from '../../../../../utils/constants';
import { Accordion } from '../Accordion/Accordion';
import s from './SectionCard.module.css';
import { SectionCardRow } from './SectionCardRow';
import { HeaderCell } from './TableCells';

export const SectionCard = ({
  currentView,
  sectionData,
  assignments,
  user,
  currentStudent,
  settings,
  isFirstCard,
  previousSectionData,
  // Display
  isDropdownOpen,
  isMobile,
  // Sorting
  onSortClick,
  sortBy,
  sortOrder,
  // Route Params
  getLaunchUrl,
  handleLocalLaunch,
  hasStudentReport,
  getStudentReportLink,
}) => {
  return (
    <Accordion
      key={sectionData.id}
      currentView={currentView}
      sectionData={sectionData}
      previousSectionData={previousSectionData}
      user={user}
      settings={settings}
      isFirstCard={isFirstCard}
      isMobile={isMobile}
    >
      <div
        className={classNames({ [s.table]: !isMobile })}
        role="table"
        aria-label="Student gradebook assignments"
      >
        {!isMobile && (
          <div
            className={s.tableRow}
            data-test-id="individual-student-gb-header"
            role="row"
          >
            {Object.values(ISG_COLUMN_HEADERS).map((header) => (
              <HeaderCell
                key={header}
                label={header}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onClick={onSortClick}
              />
            ))}
          </div>
        )}
        {assignments?.map((assignment) => {
          if (!assignment.isAssigned) return null;
          return (
            <SectionCardRow
              key={assignment?.id}
              currentView={currentView}
              assignment={assignment}
              user={user}
              currentStudent={currentStudent}
              settings={settings}
              // Display
              isTotal={false}
              isDropdownOpen={isDropdownOpen}
              isMobile={isMobile}
              // Route Params
              getLaunchUrl={getLaunchUrl}
              handleLocalLaunch={handleLocalLaunch}
              getStudentReportLink={getStudentReportLink}
              hasStudentReport={hasStudentReport}
            />
          );
        })}
      </div>
    </Accordion>
  );
};
